import * as React from 'react';

import { Spinner } from 'components/common';
import { Row, Col } from 'security-app/components/common/FormBaseStyles';
import { useGetAssetsByIds } from 'security-app/hooks/useAssetsAPI';
import type { AssetAPIType, AssetDetailsType } from 'security-app/hooks/api/assetsAPI.types';

import AssetDetailsOverlay from './AssetDetailsOverlay';

type DirectionType = 'col' | 'row';

type Props = {
  assetIds: string[];
  direction?: DirectionType;
  addToQuery?: (id: string) => void;
};

function AssocAsssetsWidget({ assetIds, direction, addToQuery }: Props) {
  const { assets, fetchingAssets } = useGetAssetsByIds(assetIds);
  const ColRow = direction === 'row' ? Row : Col;

  if (fetchingAssets) return <Spinner text="Loading Associated Assets" />;

  if (assets.length < 1) return null;

  return (
    <ColRow $gap="0.5rem">
      {assets.map((asset: AssetAPIType<AssetDetailsType>) => (
        <AssetDetailsOverlay key={asset.id} asset={asset} addToQuery={addToQuery} />
      ))}
    </ColRow>
  );
}

AssocAsssetsWidget.defaultProps = {
  direction: 'row' as DirectionType,
  addToQuery: undefined,
};

export default AssocAsssetsWidget;
